export enum DateFormatEnum {
    default = 'dd/MM/yyyy',
    hu = 'yyyy.MM.dd.',
}